import useQueryParams from '@common/src/hooks/useQueryParams';
import { useAnvaFlowsInsurances } from '@flows/src/api/anva-flows/getAnvaFlowsInsurances';
import { PartyType } from '@parties/src/types';

interface InsuranceNameResponse {
  insuranceName: string;
  getInsuranceName: (insuranceId: string) => string;
}

const useAnvaInsuranceName = (insuranceId?: string): InsuranceNameResponse => {
  const queryparams = useQueryParams();
  const partyType = (queryparams.get('type') as PartyType) || 'CUSTOMER';
  const { data: insuranceData } = useAnvaFlowsInsurances(partyType);
  const insuranceName = insuranceData?.items.find(
    (insurance) => insurance.id === insuranceId,
  )?.name;

  const getInsuranceName = (id: string) => {
    return (
      insuranceData?.items.find((insurance) => insurance.id === id)?.name || ''
    );
  };
  return {
    insuranceName: insuranceName || '',
    getInsuranceName,
  };
};

export default useAnvaInsuranceName;
